import { createContext } from "react";

export interface LoginData {
  access_token: string;
  user_id: number;
  client_id: number;
  user_name?: string;
}

export interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (data: LoginData) => void;
  logout: () => Promise<void>;
  token: string | null;
  userId: number | null;
  userName?: string;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);
